import React from 'react'
import InventoryForm from './RequisitionComponents/OsRequisitionInventoryForm';

const OsrRequisitionTrans = () => {
  return (
    <div>
      <InventoryForm permissionType="TRANS" />
    </div>
  )
}

export default OsrRequisitionTrans
